import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'
import User, { IUser } from 'modules/core/store/models/User'

// FIXME: Core must not be coupled with other modules.
import type QuestionGroup from 'modules/surveys/store/models/QuestionGroup'

export class Users extends Collection<User> {
  constructor(data = []) {
    super(data)
    makeObservable(this, {
      current: computed,
    })
  }

  get cacheKey(): string {
    return 'users'
  }

  get indexes() {
    return ['current', 'email']
  }

  /**
   * @deprecated Before using this method, consider using the `useCurrentSession` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  get current(): User {
    const user = this.find({
      current: true,
    })

    if (!user) {
      throw Error('Error finding users with current = true')
    }

    return user
  }

  async findOrCreate(attributes: Partial<IUser>): Promise<IUser> {
    const existingUser = this.find({ email: attributes.email })

    if (existingUser) {
      return existingUser.toJS()
    }

    return await this.create(attributes)
  }

  model() {
    return User
  }
}

const singleton: Users = new Users()

export const questionGroupRespondent = (questionGroup: QuestionGroup) => {
  return singleton.get(questionGroup.attributes.respondent_id)
}
export default singleton
